import { Button, DataSource, Layout, Switch, Table } from "@mcleod/components";

export abstract class AutogenLayoutTenantConnect extends Layout {
    buttonConnect: Button;
    sourceTenant: DataSource;
    switchIncludeMcLeod: Switch;
    tableTenants: Table;
}
